import { render, staticRenderFns } from "./PremiumImageLightbox.vue?vue&type=template&id=0e8e5370"
import script from "./PremiumImageLightbox.vue?vue&type=script&lang=js"
export * from "./PremiumImageLightbox.vue?vue&type=script&lang=js"
import style0 from "./PremiumImageLightbox.vue?vue&type=style&index=0&id=0e8e5370&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports